import React from "react";
import { MapPin, Clock } from "lucide-react";
import { Product } from "@/services/marketplace";
import { cn } from "@/lib/utils";

interface ProductCardProps {
  product: Product;
  className?: string;
  onClick?: () => void;
}

export const ProductCard: React.FC<ProductCardProps> = ({
  product,
  className,
  onClick,
}) => {
  const formatPrice = (price: string) => {
    // Remove non-numeric characters and parse as number
    const numericPrice = parseFloat(price.replace(/[^\d]/g, ""));
    // Format with dots as thousand separators and add đ
    return numericPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "đ";
  };

  return (
    <div
      className={cn(
        "w-[170px] h-[240px] relative bg-[#FBF6F1] rounded-lg shadow-[0px_1px_4px_0px_rgba(12,12,13,0.05)] flex flex-col justify-start items-center cursor-pointer",
        className,
      )}
      onClick={onClick}
    >
      <img
        src={product.image}
        alt={product.name}
        className="w-full h-[140px] rounded-tl-lg rounded-tr-lg object-cover flex-shrink-0"
      />
      <div className="w-full h-[100px] p-2 flex flex-col justify-start items-start gap-1 flex-shrink-0">
        <div className="w-full text-[#1E3A3A] text-sm font-medium font-sora leading-tight truncate">
          {product.name}
        </div>
        <div className="w-full text-[#E06448] text-base font-semibold font-manrope leading-tight truncate">
          {formatPrice(product.price)}
        </div>
        <div className="flex justify-start items-center gap-1 w-full">
          <div className="w-3.5 h-3.5  flex-shrink-0">
            <MapPin className="h-3.5 w-3.5 text-[#6F6F6B]" />
          </div>
          <div className="text-[#6F6F6B] text-xs font-normal font-sora leading-none">
            {product.location}
          </div>
          <div className="w-0.5 h-0.5 bg-[#6F6F6B] rounded-full flex-shrink-0"></div>
          <div className="text-[#6F6F6B] text-xs font-normal font-sora leading-none truncate">
            {product.distance}
          </div>
        </div>
        <div className="flex justify-start items-center gap-1 w-full">
          <div className="w-3.5 h-3.5 relative overflow-hidden flex-shrink-0">
            <Clock className="h-3.5 w-3.5 text-[#6F6F6B]" />
          </div>
          <div className="text-[#6F6F6B] text-xs font-normal font-sora leading-none truncate flex-1">
            {product.time}
          </div>
        </div>
      </div>
      {product.discount && (
        <div
          data-property-1="discount"
          className="size- px-3 py-1 right-2 top-2 absolute bg-[#FEE4E2] rounded-full inline-flex justify-center items-center gap-2.5"
        >
          <div className="justify-start text-[#F04438] text-[10px] font-normal font-sora leading-none">
            -{product.discount}
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductCard;
